/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * UserStreakResponseBase
 * auto generated base class for the model UserStreakResponseModel.
 */
export const UserStreakResponseModelBase = ModelBase.named('UserStreakResponse')
  .props({
    __typename: types.optional(types.literal('UserStreakResponse'), 'UserStreakResponse'),
    days: types.union(types.undefined, types.array(types.string)),
    streakCount: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserStreakResponseModelSelector extends QueryBuilder {
  get days() {
    return this.__attr('days')
  }
  get streakCount() {
    return this.__attr('streakCount')
  }
}
export function selectFromUserStreakResponse() {
  return new UserStreakResponseModelSelector()
}

export const userStreakResponseModelPrimitives = selectFromUserStreakResponse().days.streakCount
